<template>
  <div class="container">
    <div class="navbar">
      <div class="title-container">
        <div class="back" @click="back">
          <img src="@/assets/image/back.png" alt="返回" />
        </div>
        <div class="title">全优能收款</div>
      </div>
    </div>
    <div class="pay pay_FAIL">
      <span>支付失败</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    methods: {
      // 返回
      back() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style scoped>
  .container {
    height: 100vh;
    width: 100%;
    position: relative;
    background: #f5f5f5;
  }
  .pay {
    padding-top: 150rem;
    height: 120rem;
    border-radius: 5rem;
    font-size: 22rem;
    text-align: center;
  }
  .pay_FAIL {
    background: #fff url(../assets/image/fail.png) no-repeat center 40rem;
    background-size: auto 80rem;
  }

  .pay_SUCCESS {
    background: #fff url(../assets/image/success.png) no-repeat center 40rem;
    background-size: auto 80rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/fail.vue